import React, { Component } from "react";

const initData = {
  iconClass: "far fa-lightbulb text-primary mr-1",
  preHeading: "Awesome",
  preHeadingspan: "Interface",
  heading: "Our Digital Lending Partners",
  headingText:
    "Loans on MoneyMonk are sanctioned by RBI-registered NBFCs/Banks disclosed during the application process.",
  headingTexttwo:
    "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati.",
};

const data = [
  {
    image:
      "https://feemonk-public.s3.ap-south-1.amazonaws.com/MONK+CAPITAL+(1080+%C3%97+1480+px).png",
  },
  // {
  //     image: "/img/screenshot_2.jpg"
  // },
  // {
  //     image: "/img/screenshot_3.jpg"
  // },
  // {
  //     image: "/img/screenshot_4.jpg"
  // },
  // {
  //     image: "/img/screenshot_5.jpg"
  // }
];

class ScreenshotSection extends Component {
  state = {
    initData: {},
    data: [],
  };
  componentDidMount() {
    this.setState({
      initData: initData,
      data: data,
    });
  }
  render() {
    return (
      <section id="partners" className="section screenshots-area ptb_100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-7">
              {/* Section Heading */}
              <div className="section-heading text-center">
                {/* <span className="d-inline-block rounded-pill shadow-sm fw-5 px-4 py-2 mb-3">
                            <i className={this.state.initData.iconClass} />
                            <span className="text-primary">{this.state.initData.preHeading}</span> {this.state.initData.preHeadingspan}
                        </span> */}
                <h2 className="text-capitalize">
                  {this.state.initData.heading}
                </h2>
                <p className="d-none d-sm-block mt-4">
                  {this.state.initData.headingText}
                </p>
                <p className="d-block d-sm-none mt-4">
                  {this.state.initData.headingTexttwo}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {/* App Screenshot Slider Area */}
              <div className="app-screenshots">
                {/* Single Screenshot Item */}
                {data.map((item, idx) => {
                  return (
                    <div
                      className="single-screenshot"
                
                    >
                      <a href={item.image} data-fancybox="images">
                        <img src={item.image} alt="Lending Partner" />
                      </a>
                      <div>
                        <p>
                          Lender:{" "}
                          <span style={{ fontWeight: 500 }}>
                            Monk Capital Pvt Ltd
                          </span>
                        </p>
                        <p>
                          Details:{" "}
                          <a
                            href="https://www.monkcapital.in"
                            style={{
                              textDecoration: "underline",
                              fontWeight: 500,
                            }}
                          >
                            www.monkcapital.in
                          </a>
                        </p>
                        <p>
                          <a
                            href="https://www.monkcapital.in/terms-conditions"
                            style={{
                              textDecoration: "underline",
                              fontWeight: 500,
                            }}
                          >
                            Terms & Conditions
                          </a>{" "}
                          and{" "}
                          <a
                            href="https://www.monkcapital.in/privacy-policy"
                            style={{
                              textDecoration: "underline",
                              fontWeight: 500,
                            }}
                          >
                            Privacy Policy
                          </a>
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ScreenshotSection;
